<template>
  <div>
    <info-text i18n="integrations.helper.inventory-blockings.edit" />
    <va-create-layout>
      <inventory-blockings-form :id="id" :item="item" :isEdit="true" />
    </va-create-layout>
  </div>
</template>

<script>
import InfoText from "@/components/helper/InfoText";
export default {
  components: { InfoText },
  props: ["id", "resource", "title", "item"]
};
</script>
